import React from 'react'
import { ReactComponent as CrossIcon } from 'assets/icons/cross.svg'
import { ReactComponent as StarsIcon } from 'assets/icons/stars.svg'
import { ReactComponent as LockIcon } from 'assets/icons/lock.svg'
import { ReactComponent as ReloadIcon } from 'assets/icons/reload.svg'
import s from './styles/Writing.module.scss'

const Writing = ({ status = 'writing', onClose, onBack, onRetry, errorMessage }) => {
	const isError = status === 'error'

	return (
		<div className={s.writing}>
			<button
				type="button"
				className={s.close}
				onClick={onClose}
				aria-label="Close"
			>
				<CrossIcon />
			</button>

			<div className={s.body}>
				{isError ? (
					<span className={s.fail}>
						<CrossIcon />
					</span>
				) : (
					<div className={s.spinner}>
						<span className={s.spinner__ring} />
						<span className={s.spinner__core}>
							<StarsIcon />
						</span>
					</div>
				)}

				<h1 className={s.title}>
					{isError
						? "We couldn't generate this letter"
						: 'Generating Letter of Recommendation...'}
				</h1>
				<p className={s.subtitle}>
					{isError
						? errorMessage ||
							'An unexpected error occurred while generating the recommendation letter. Please try again in a moment.'
						: 'Please keep this window open while Koda drafts your letter.'}
				</p>
			</div>

			{isError ? (
				<footer className={s.actions}>
					<button type="button" className={s.back} onClick={onBack}>
						Back to settings
					</button>
					<button type="button" className={s.retry} onClick={onRetry}>
						<ReloadIcon />
						Try again
					</button>
				</footer>
			) : (
				<footer className={s.footer}>
					<span className={s.footer__icon}>
						<LockIcon />
					</span>
					<span className={s.footer__text}>
						This may take up to 10–20 seconds.
						<br />
						Please don't close this window.
					</span>
				</footer>
			)}
		</div>
	)
}

export default Writing
